import { FormSchema } from "../../../interfaces/components/form";
import { FormComponent } from "../../utils/enums";

export const addNewPatient: FormSchema = {
  type: "object",
  properties: {
    first_name: {
      label: "First Name",
      type: "string",
      required: true,
      component: FormComponent.Input,
      section: "Personal Information",
      componentProps: {
        placeholder: "Enter first name",
        type: "text",
      },
    },
    last_name: {
      label: "Last Name",
      type: "string",
      required: true,
      component: FormComponent.Input,
      section: "Personal Information",
      componentProps: {
        placeholder: "Enter last name",
        type: "text",
      },
    },
    middle_name: {
      label: "Middle Name",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Personal Information",
      componentProps: {
        placeholder: "Enter middle name",
        type: "text",
      },
    },
    mother_name: {
      label: "Mother's Name",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Personal Information",
      componentProps: {
        placeholder: "Enter mother's full name",
        type: "text",
      },
    },
    email: {
      label: "Email Address",
      type: "email",
      format: "email",
      required: false,
      component: FormComponent.Input,
      section: "Contact Information",
      componentProps: {
        placeholder: "patient@email.com",
        type: "email",
      },
    },
    dob: {
      label: "Date of Birth",
      type: "date",
      required: true,
      component: FormComponent.DatePicker,
      section: "Personal Information",
      componentProps: {
        placeholder: "Select date of birth",
        showTime: false,
      },
    },
    gender: {
      label: "Gender",
      type: "string",
      required: true,
      component: FormComponent.Select,
      section: "Personal Information",
      componentProps: {
        placeholder: "Select Gender",
        options: [
          { label: "Male", value: "male" },
          { label: "Female", value: "female" },
          { label: "Other", value: "other" },
        ],
      },
    },
    nationality: {
      label: "Nationality",
      type: "string",
      required: true,
      component: FormComponent.Select,
      section: "Personal Information",
      componentProps: {
        placeholder: "Select Nationality",
        options: [
          { label: "Lebanese", value: "Lebanese" },
          { label: "Syrian", value: "Syrian" },
          { label: "Palestinian", value: "Palestinian" },
          { label: "Egyptian", value: "Egyptian" },
          { label: "Jordanian", value: "Jordanian" },
          { label: "Iraqi", value: "Iraqi" },
          { label: "Other", value: "Other" },
        ],
      },
    },
    civil_status: {
      label: "Civil Status",
      type: "string",
      required: false,
      component: FormComponent.Select,
      section: "Personal Information",
      componentProps: {
        placeholder: "Select Civil Status",
        options: [
          { label: "Single", value: "single" },
          { label: "Married", value: "married" },
          { label: "Divorced", value: "divorced" },
          { label: "Widowed", value: "widowed" },
        ],
      },
    },
    religion: {
      label: "Religion",
      type: "string",
      required: false,
      component: FormComponent.Select,
      section: "Personal Information",
      componentProps: {
        placeholder: "Select Religion",
        options: [
          { label: "Islam", value: "Islam" },
          { label: "Christianity", value: "Christianity" },
          { label: "Judaism", value: "Judaism" },
          { label: "Druze", value: "Druze" },
          { label: "Other", value: "Other" },
        ],
      },
    },
    mobile_number: {
      label: "Mobile Number",
      type: "string",
      required: true,
      component: FormComponent.Input,
      section: "Contact Information",
      componentProps: {
        placeholder: "+961-XX-XXX-XXX",
        type: "tel",
        mask: "+961-XX-XXX-XXX",
      },
    },
    landline: {
      label: "Landline",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Contact Information",
      componentProps: {
        placeholder: "+961-X-XXX-XXX",
        type: "tel",
        mask: "+961-X-XXX-XXX",
      },
    },
    street: {
      label: "Street",
      type: "string",
      required: true,
      component: FormComponent.Input,
      section: "Address",
      componentProps: {
        placeholder: "Street address",
        type: "text",
      },
    },
    building: {
      label: "Building",
      type: "string",
      required: true,
      component: FormComponent.Input,
      section: "Address",
      componentProps: {
        placeholder: "Building name/number",
        type: "text",
      },
    },
    floor: {
      label: "Floor",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Address",
      componentProps: {
        placeholder: "Floor number",
        type: "text",
      },
    },
    city: {
      label: "City",
      type: "string",
      required: true,
      component: FormComponent.Select,
      section: "Address",
      componentProps: {
        placeholder: "Select City",
        options: [
          { label: "Beirut", value: "Beirut" },
          { label: "Tripoli", value: "Tripoli" },
          { label: "Saida", value: "Saida" },
          { label: "Tyre", value: "Tyre" },
          { label: "Jounieh", value: "Jounieh" },
          { label: "Zahle", value: "Zahle" },
          { label: "Baalbek", value: "Baalbek" },
          { label: "Nabatieh", value: "Nabatieh" },
          { label: "Batroun", value: "Batroun" },
          { label: "Jbeil", value: "Jbeil" },
          { label: "Other", value: "Other" },
        ],
      },
    },
    area: {
      label: "Area",
      type: "string",
      required: true,
      component: FormComponent.Select,
      section: "Address",
      componentProps: {
        placeholder: "Select Area",
        options: [
          // Beirut areas
          { label: "Ashrafieh", value: "Ashrafieh", data: { city: "Beirut" } },
          { label: "Hamra", value: "Hamra", data: { city: "Beirut" } },
          { label: "Verdun", value: "Verdun", data: { city: "Beirut" } },
          {
            label: "Ain El Mreisseh",
            value: "Ain El Mreisseh",
            data: { city: "Beirut" },
          },
          {
            label: "Ras Beirut",
            value: "Ras Beirut",
            data: { city: "Beirut" },
          },
          { label: "Gemmayzeh", value: "Gemmayzeh", data: { city: "Beirut" } },
          {
            label: "Mar Mikhael",
            value: "Mar Mikhael",
            data: { city: "Beirut" },
          },
          { label: "Badaro", value: "Badaro", data: { city: "Beirut" } },
          { label: "Mazraa", value: "Mazraa", data: { city: "Beirut" } },
          {
            label: "Bourj Hammoud",
            value: "Bourj Hammoud",
            data: { city: "Beirut" },
          },
          { label: "Achrafieh", value: "Achrafieh", data: { city: "Beirut" } },
          { label: "Saifi", value: "Saifi", data: { city: "Beirut" } },
          { label: "Downtown", value: "Downtown", data: { city: "Beirut" } },
          { label: "Karantina", value: "Karantina", data: { city: "Beirut" } },
          { label: "Nabaa", value: "Nabaa", data: { city: "Beirut" } },
          {
            label: "Sin El Fil",
            value: "Sin El Fil",
            data: { city: "Beirut" },
          },
          {
            label: "Furn El Chebbak",
            value: "Furn El Chebbak",
            data: { city: "Beirut" },
          },
          { label: "Hazmieh", value: "Hazmieh", data: { city: "Beirut" } },
          { label: "Baabda", value: "Baabda", data: { city: "Beirut" } },
          { label: "Hadath", value: "Hadath", data: { city: "Beirut" } },
          { label: "Chiyah", value: "Chiyah", data: { city: "Beirut" } },
          { label: "Ghobeiry", value: "Ghobeiry", data: { city: "Beirut" } },
          {
            label: "Haret Hreik",
            value: "Haret Hreik",
            data: { city: "Beirut" },
          },
          {
            label: "Bourj El Barajneh",
            value: "Bourj El Barajneh",
            data: { city: "Beirut" },
          },
          { label: "Ouzai", value: "Ouzai", data: { city: "Beirut" } },
          { label: "Khaldeh", value: "Khaldeh", data: { city: "Beirut" } },
          { label: "Damour", value: "Damour", data: { city: "Beirut" } },
          { label: "Jiyeh", value: "Jiyeh", data: { city: "Beirut" } },
          { label: "Naameh", value: "Naameh", data: { city: "Beirut" } },
          { label: "Jounieh", value: "Jounieh", data: { city: "Jounieh" } },
          {
            label: "Zouk Mikael",
            value: "Zouk Mikael",
            data: { city: "Jounieh" },
          },
          {
            label: "Zouk Mosbeh",
            value: "Zouk Mosbeh",
            data: { city: "Jounieh" },
          },
          { label: "Dbayeh", value: "Dbayeh", data: { city: "Jounieh" } },
          {
            label: "Maameltein",
            value: "Maameltein",
            data: { city: "Jounieh" },
          },
          { label: "Tabarja", value: "Tabarja", data: { city: "Jounieh" } },
          { label: "Tripoli", value: "Tripoli", data: { city: "Tripoli" } },
          { label: "El Mina", value: "El Mina", data: { city: "Tripoli" } },
          { label: "Qalamoun", value: "Qalamoun", data: { city: "Tripoli" } },
          { label: "Saida", value: "Saida", data: { city: "Saida" } },
          { label: "Tyre", value: "Tyre", data: { city: "Tyre" } },
          { label: "Zahle", value: "Zahle", data: { city: "Zahle" } },
          { label: "Baalbek", value: "Baalbek", data: { city: "Baalbek" } },
          { label: "Nabatieh", value: "Nabatieh", data: { city: "Nabatieh" } },
          { label: "Batroun", value: "Batroun", data: { city: "Batroun" } },
          { label: "Jbeil", value: "Jbeil", data: { city: "Jbeil" } },
          { label: "Other", value: "Other", data: { city: "Other" } },
        ],
      },
    },
    governorate: {
      label: "Governorate",
      type: "string",
      required: true,
      component: FormComponent.Select,
      section: "Address",
      componentProps: {
        placeholder: "Select Governorate",
        options: [
          { label: "Beirut", value: "Beirut" },
          { label: "Mount Lebanon", value: "Mount Lebanon" },
          { label: "North Lebanon", value: "North Lebanon" },
          { label: "South Lebanon", value: "South Lebanon" },
          { label: "Bekaa", value: "Bekaa" },
          { label: "Nabatieh", value: "Nabatieh" },
          { label: "Akkar", value: "Akkar" },
        ],
      },
    },
    // Insurance Information
    primary_insurance_type: {
      label: "Primary Insurance Type",
      type: "string",
      required: true,
      component: FormComponent.Select,
      section: "Insurance Information",
      componentProps: {
        placeholder: "Select Insurance Type",
        options: [
          { label: "NSSF", value: "nssf" },
          { label: "MOPH", value: "moph" },
          { label: "Private", value: "private" },
          { label: "Cooperative", value: "cooperative" },
          { label: "None", value: "none" },
        ],
      },
    },
    nssf_number: {
      label: "NSSF Number",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Insurance Information",
      componentProps: {
        placeholder: "123456/1",
        type: "text",
      },
      conditions: [{ field: "primary_insurance_type", value: "nssf" }],
      validator: [
        {
          regex: "^\\d{1,8}(\\/\\d{1,2})?$",
          message: "Invalid NSSF number format.",
        },
      ],
    },
    ministry_health_card_number: {
      label: "MOPH Card Number",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Insurance Information",
      componentProps: {
        placeholder: "MOH123456",
        type: "text",
      },
      conditions: [{ field: "primary_insurance_type", value: "moph" }],
    },
    insurance_provider: {
      label: "Insurance Provider",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Insurance Information",
      componentProps: {
        placeholder: "Insurance company name",
        type: "text",
      },
      conditions: [
        {
          field: "primary_insurance_type",
          value: ["private", "cooperative"],
        },
      ],
    },
    insurance_number: {
      label: "Insurance Number",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Insurance Information",
      componentProps: {
        placeholder: "Policy number",
        type: "text",
      },
      conditions: [
        {
          field: "primary_insurance_type",
          value: ["private", "cooperative"],
        },
      ],
    },
    insurance_group_number: {
      label: "Group Number",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Insurance Information",
      componentProps: {
        placeholder: "Group insurance number",
        type: "text",
      },
      conditions: [
        {
          field: "primary_insurance_type",
          value: ["private", "cooperative"],
        },
      ],
    },
    employer: {
      label: "Employer",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Insurance Information",
      componentProps: {
        placeholder: "Employer name",
        type: "text",
      },
    },
    employer_registration_number: {
      label: "Employer Registration Number",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Insurance Information",
      componentProps: {
        placeholder: "EMP-123456",
        type: "text",
      },
      validator: [
        {
          regex: "^[A-Z]{3}-\\d{1,6}$",
          message: "Invalid Employer Registration Number format.",
        },
      ],
    },
    family_registration_id: {
      label: "Family Registration ID",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Identification",
      componentProps: {
        placeholder: "Family registration ID",
        type: "text",
      },
    },
    passport_number: {
      label: "Passport Number",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Identification",
      componentProps: {
        placeholder: "LP123456",
        type: "text",
      },
      validator: [
        {
          regex: "^[A-Z]{2}\\d{6,10}$",
          message: "Invalid passport number format.",
        },
      ],
    },
    national_id_number: {
      label: "National ID Number",
      type: "string",
      required: true,
      component: FormComponent.Input,
      section: "Identification",
      componentProps: {
        placeholder: "123456",
        type: "text",
      },
      validator: [
        {
          regex: "^\\d{6,}$",
          message: "National ID must be at least 6 digits.",
        },
      ],
    },
    // Secondary Insurance Information
    has_secondary_insurance: {
      label: "Has Secondary Insurance?",
      type: "boolean",
      required: false,
      component: FormComponent.Checkbox,
      section: "Insurance Information",
      componentProps: {},
    },
    secondary_insurance_provider: {
      label: "Secondary Insurance Provider",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Insurance Information",
      componentProps: {
        placeholder: "Secondary insurance company name",
        type: "text",
      },
      conditions: [{ field: "has_secondary_insurance", value: true }],
    },
    secondary_insurance_number: {
      label: "Secondary Insurance Number",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Insurance Information",
      componentProps: {
        placeholder: "Secondary policy number",
        type: "text",
      },
      conditions: [{ field: "has_secondary_insurance", value: true }],
    },
    insurance_policy_holder_name: {
      label: "Policy Holder Name",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Insurance Information",
      componentProps: {
        placeholder: "Name of policy holder",
        type: "text",
      },
    },
    insurance_policy_holder_relationship: {
      label: "Relationship to Policy Holder",
      type: "string",
      required: false,
      component: FormComponent.Select,
      section: "Insurance Information",
      componentProps: {
        placeholder: "Select Relationship",
        options: [
          { label: "Self", value: "self" },
          { label: "Spouse", value: "spouse" },
          { label: "Parent", value: "parent" },
          { label: "Child", value: "child" },
          { label: "Sibling", value: "sibling" },
          { label: "Dependent", value: "dependent" },
        ],
      },
    },
    insurance_effective_date: {
      label: "Insurance Effective Date",
      type: "date",
      required: false,
      component: FormComponent.DatePicker,
      section: "Insurance Information",
      componentProps: {
        placeholder: "Select effective date",
        showTime: false,
      },
    },
    insurance_expiry_date: {
      label: "Insurance Expiry Date",
      type: "date",
      required: false,
      component: FormComponent.DatePicker,
      section: "Insurance Information",
      componentProps: {
        placeholder: "Select expiry date",
        showTime: false,
      },
    },
    // Emergency Contact
    emergency_contact_name: {
      label: "Emergency Contact Name",
      type: "string",
      required: true,
      component: FormComponent.Input,
      section: "Emergency Contact",
      componentProps: {
        placeholder: "Emergency contact full name",
        type: "text",
      },
    },
    emergency_contact_phone: {
      label: "Emergency Contact Phone",
      type: "string",
      required: true,
      component: FormComponent.Input,
      section: "Emergency Contact",
      componentProps: {
        placeholder: "+961-XX-XXX-XXX",
        type: "tel",
        mask: "+961-XX-XXX-XXX",
      },
    },
    emergency_contact_relationship: {
      label: "Relationship to Emergency Contact",
      type: "string",
      required: false,
      component: FormComponent.Select,
      section: "Emergency Contact",
      componentProps: {
        placeholder: "Select Relationship",
        options: [
          { label: "Spouse", value: "spouse" },
          { label: "Parent", value: "parent" },
          { label: "Child", value: "child" },
          { label: "Sibling", value: "sibling" },
          { label: "Friend", value: "friend" },
          { label: "Other", value: "other" },
        ],
      },
    },
    emergency_contact_address: {
      label: "Emergency Contact Address",
      type: "string",
      required: false,
      component: FormComponent.Input,
      section: "Emergency Contact",
      componentProps: {
        placeholder: "Emergency contact address",
        type: "text",
      },
    },
    // Preferences
    preferred_currency: {
      label: "Preferred Currency",
      type: "string",
      required: false,
      component: FormComponent.Select,
      section: "Preferences",
      componentProps: {
        placeholder: "Select Preferred Currency",
        options: [
          { label: "USD", value: "USD" },
          { label: "LBP", value: "LBP" },
          { label: "EUR", value: "EUR" },
        ],
      },
    },
    financial_class: {
      label: "Financial Class",
      type: "string",
      required: false,
      component: FormComponent.Select,
      section: "Preferences",
      componentProps: {
        placeholder: "Select Financial Class",
        options: [
          { label: "Self Pay", value: "self_pay" },
          { label: "Insured", value: "insured" },
          { label: "Charity", value: "charity" },
          { label: "Government", value: "government" },
        ],
      },
    },
    // Medical Information (Textarea fields)
    blood_type: {
      label: "Blood Type",
      type: "string",
      required: false,
      component: FormComponent.Select,
      section: "Medical Information",
      componentProps: {
        placeholder: "Select Blood Type",
        options: [
          { label: "A+", value: "A+" },
          { label: "A-", value: "A-" },
          { label: "B+", value: "B+" },
          { label: "B-", value: "B-" },
          { label: "AB+", value: "AB+" },
          { label: "AB-", value: "AB-" },
          { label: "O+", value: "O+" },
          { label: "O-", value: "O-" },
        ],
      },
    },
    preexisting_conditions: {
      label: "Preexisting Conditions",
      type: "string",
      required: false,
      component: FormComponent.Select,
      section: "Medical Information",
      componentProps: {
        placeholder: "Enter conditions and press Enter",
        mode: "tags",
        options: [
          { label: "Hypertension", value: "Hypertension" },
          { label: "Diabetes", value: "Diabetes" },
          { label: "Asthma", value: "Asthma" },
          { label: "Heart Disease", value: "Heart Disease" },
          { label: "High Cholesterol", value: "High Cholesterol" },
          { label: "Chronic Kidney Disease", value: "Chronic Kidney Disease" },
          { label: "COPD", value: "COPD" },
          { label: "Arthritis", value: "Arthritis" },
        ],
      },
    },
    allergies: {
      label: "Allergies",
      type: "string",
      required: false,
      component: FormComponent.Select,
      section: "Medical Information",
      componentProps: {
        placeholder: "Enter allergies and press Enter",
        mode: "tags",
        options: [
          { label: "Penicillin", value: "Penicillin" },
          { label: "Aspirin", value: "Aspirin" },
          { label: "Sulfa drugs", value: "Sulfa drugs" },
          { label: "Nuts", value: "Nuts" },
          { label: "Shellfish", value: "Shellfish" },
          { label: "Milk", value: "Milk" },
          { label: "Soy", value: "Soy" },
          { label: "Wheat", value: "Wheat" },
        ],
      },
    },
    patient_photo: {
      label: "Patient Photo",
      type: "string",
      required: false,
      component: FormComponent.ImageUploader,
      section: "Photo",
      componentProps: {
        placeholder: "Upload patient photo",
      },
    },
  },
};
